export class Addigital
{
    constructor() {
        this.init();
    }

    init() {
        window._tmr = window._tmr || [];
        return window._tmr;
    }

    push(query) {
        window._tmr.push(query);
    }

    indexPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'home'
        }));
    }

    categoryPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'category'
        }));
    }

    productPageView(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'product',
            productid: product.id,
            totalvalue: parseFloat(product.price),
        }));
    }

    orderPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'purchase'
        }));
    }

    orderThankyouPageView(basket) {
        let ids = [], totalPrice = 0.0;
        basket.forEach(product => {
            ids.push(product.id);
            totalPrice += parseFloat(product.price) * product.quantity;;
        });
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'purchase',
            productid: ids,
            totalvalue: totalPrice,
        }));
    }

    basketPageView(basket) {
        let ids = [], totalPrice = 0.0;
        basket.forEach(product => {
            ids.push(product.id);
            totalPrice += parseFloat(product.price) * product.quantity;;
        });
        
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'cart',
            productid: ids.join(),
            totalvalue: totalPrice,
        }));
    }

    searchPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'searchresults'
        }));
    }

    addToCart(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'cart',
            productid: product.id
        }));
    }

    getQueryTemplate() {
        return {
            id: '3109235',
            type: 'itemView',
            productid: '',
            pagetype: 'other',
            totalvalue: '',
            list: '1'
        }
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/addigital.js